import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { EffectsModule } from '@ngrx/effects';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { OptionPanelComponent } from 'packages/sports/web/app/src/option-group/option-panel.component';

import { LineSwitcherDialogContainerComponent } from './components/line-switcher-dialog-container.component';
import { LineSwitcherDialogHeaderComponent } from './components/line-switcher-dialog-header.component';
import { LineSwitcherDialogSportComponent } from './components/line-switcher-dialog-sport.component';
import { LineSwitcherSwapButtonComponent } from './components/line-switcher-swap-button.component';
import { LineSwitcherEffects } from './effects/effects';
import { LineSwitcherTrackingEffects } from './effects/tracking.effects';
import { LineSwitcherUiChangeHandler } from './line-switcher-ui-change-handler';
import { LineSwitcherDialogService } from './services/line-switcher-dialog.service';
import LineSwitcherInputBuilderService from './services/line-switcher-input-builder';
import { LineSwitcherSwapOptionsService } from './services/line-switcher-swap-options.service';
import { LineSwitcherUtils } from './services/line-switcher-utils.service';

@NgModule({
    declarations: [
        LineSwitcherSwapButtonComponent,
        LineSwitcherDialogContainerComponent,
        LineSwitcherDialogHeaderComponent,
        LineSwitcherDialogSportComponent,
    ],
    imports: [
        CommonModule,
        NgScrollbarModule,
        EffectsModule.forFeature([LineSwitcherTrackingEffects, LineSwitcherEffects]),
        DsButton,
        ShowInEpcotDirective,
        OptionPanelComponent,
    ],
    providers: [
        LineSwitcherUtils,
        LineSwitcherInputBuilderService,
        LineSwitcherDialogService,
        LineSwitcherUiChangeHandler,
        LineSwitcherSwapOptionsService,
    ],
})
export class LineSwitcherModule {
    constructor(uiHandler: LineSwitcherUiChangeHandler) {
        uiHandler.onAppInit();
    }
}
